import swal from "sweetalert";
import "./style.css";

export const errorAlert = ({ title, message }) => {
  swal({
    closeOnEsc: false,
    closeOnClickOutside: false,
    title: title,
    text: message,
  });
};
